// TheFounders.js
import React from 'react';
import './TheFounders.css';
import siteConfig from '../../configuration/siteConfiguration';
//import { FaLinkedin } from 'react-icons/fa'; // Assuming react-icons is installed

const TheFounders = () => {
  return (
    <section className="the-founders-section">
      <div className="founders-header">
        <div className="wave-bg">
          <img src="/images/wave.svg" alt="" />
        </div>
        <h3>- THE FOUNDERS</h3>
        <h2>People who coined</h2>
      </div>
      <div className="founders-container">
        <div className="founder-column">
          <div className="founder-image-placeholder">
            <img src={`${siteConfig.assetBaseUrl}/founders/DSC_7306.jpg`} height="200px" alt="Divya Singh" />
          </div>
          <div className="founder-details">
            <div className="founder-name-title">
              <h4>Divya Singh</h4>
              <p className="founder-title">Co-Founder & CEO</p>
            </div>
            <a href="#" className="linkedin-link">
              <img src="/images/socialicon.svg" alt="LinkedIn" className="linkedin-icon" />
            </a>
          </div>
          <p className="founder-description">
            A visionary with a techno-commercial mindset and over <strong>25 years of experience</strong> across
            Oracle, IBM, Accenture, Genpact, and Salesforce. An alumna of <strong>IIM and ISB</strong>, Divya brings deep expertise in enterprise transformation, regulated industry operations, and global delivery models.
          </p>
          <p className="founder-description">
            At Cognitva, Divya leads <strong>platform strategy, vertical focus, ecosystem partnerships, and go-to-market execution.</strong>
            &nbsp;She is the principal architect of Cognitva’s dual-product vision - positioning <strong>CIP™ as the intelligence foundation</strong> and
            <strong>Ideonix™ as the productization engine</strong> that enables scalable enterprise adoption.
          </p>
        </div>

        <div className="founder-column">
          <div className="founder-image-placeholder">
            <img src={`${siteConfig.assetBaseUrl}/founders/DSC_7105.jpg`} height="200px" alt="Ram B Adhikari" />
          </div>
          <div className="founder-details">
            <div className="founder-name-title">
              <h4>Ram B Adhikari</h4>
              <p className="founder-title">Co-Founder & CTO</p>
            </div>
            <a href="#" className="linkedin-link">
              <img src="/images/socialicon.svg" alt="LinkedIn" className="linkedin-icon" />
            </a>
          </div>
          <p className="founder-description">
            An <strong>IIT alumnus</strong> and AI systems architect with leadership experience at
            Microsoft, Amazon, Intuit, and Salesforce.
            Ram is the chief architect behind <strong>Cognitva CIP™ and Ideonix™</strong>, designing their modular intelligence blocks, agent orchestration, and governance frameworks
          </p>
          <p className="founder-description">
            He leads AI research, platform engineering, and infrastructure - ensuring Cognitva’s systems
            are <strong>explainable, secure, and production-ready</strong> across healthcare, manufacturing, and legal domains.
          </p>
        </div>
      </div>
    </section>
  );
};

export default TheFounders;